import { DocumentFile } from './types'

/** Uloží dokument doručený jako base64 přes dočasný odkaz. */
export function saveDocumentFile(file: DocumentFile): void {
  const binary = atob(file.content)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  saveBlob(new Blob([bytes], { type: file.mimeType }), file.fileName)
}

/** Uloží binární odpověď (např. PDF přímo z BE) přes dočasný odkaz. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  // Firefox spustí programový click jen u odkazu připojeného k dokumentu;
  // revoke musí počkat na další tick, jinak Safari stahování zruší.
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
